module.exports = __webpack_public_path__ + "static/media/ineligible.2f8b85c3.png";